import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import moment from "moment";

const getListDistributionGroups = () => {
    //[##PATH ROUTE##]
    return axios.get(`/api/notification/distgroup/list`, { headers: authHeaderJson() } );
}
const addDistributionGroup = (distributionGroup) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/notification/distgroup/add`, distributionGroup, { headers: authHeaderJson() });
}
const postListDistributionGroup = (distributionGroupList) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/notification/distgroup/add/list`, distributionGroupList, { headers: authHeaderJson() } );
}
const updateDistributionGroup = (distributionGroupId, distributionGroup) => {
    //[##PATH ROUTE##]
    return axios.put(`/api/notification/distgroup/update/${distributionGroupId}`, distributionGroup, { headers: authHeaderJson() });
}
const removeDistributionGroup = (distributionGroupId) => {
    //[##PATH ROUTE##]
    return axios.delete(`/api/notification/distgroup/delete/${distributionGroupId}`, { headers: authHeaderJson() });
};

const getListUSerDistributionGroup = (distributionGroupId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/notification/distgroup/user/list/${distributionGroupId}`, { headers: authHeaderJson() } );
}

const postDistributiongroup = (distributionGroupUser) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/notification/distgroup/user/add`, distributionGroupUser, { headers: authHeaderJson() } );
}

const postDistributiongroupList = (distributionGroupUserList) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/notification/distgroup/user/add/list`, distributionGroupUserList, { headers: authHeaderJson() } );
}
const getUsers = () => {
    //[##PATH ROUTE##]
    return axios.get(`/api/notification/distgroup/users`, { headers: authHeaderJson() } )
};

const removeUserDistributionGroup = (distributionGroupId) => {
    //[##PATH ROUTE##]
    return axios.delete(`/api/notification/distgroup/user/delete/${distributionGroupId}`, { headers: authHeaderJson() });
};



export {
    getListDistributionGroups,
    addDistributionGroup,
    updateDistributionGroup,
    postListDistributionGroup,
    removeDistributionGroup,
    postDistributiongroup,
    postDistributiongroupList,
    getListUSerDistributionGroup,
    getUsers,
    removeUserDistributionGroup
}